import { Row, Col, Input, Button, Form, Checkbox, Modal, Select, Tag } from "antd";
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import Icon from "@mdi/react";
import axios from "axios";
import { mdiArrowLeft } from "@mdi/js";
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import environment from "../../../../../config/environment";

const ConsentBackInformationPage = () => {
  const location: any = useLocation()
  const history = useHistory();
  const [isCheck, setIsCheck] = useState(false);
  const dt = new Date();
  const { t } = useTranslation(namespaces.pages.daolinv);
  const [taxYear, setTaxYear] = useState<string[]>([]);

  function onSubmit() {
    const url = `${environment?.baseApi}/updateConsentRMFBelated`
    axios.post(url, {
      customerName: location?.state?.customerName,
      customerId: location?.state?.customerId,
      taxId: location?.state?.taxId,
      taxYear: taxYear,
      phoneNumber: location?.state?.phoneNumber,
    })
      .then(res => {
        if (res.status === 200) {
          history.push({
            pathname: "/contents/daolInv/consentRMF/finish",
            state: {
              customerName: location?.state?.customerName,
              customerId: location?.state?.customerId,
              taxId: location?.state?.taxId,
              taxYear: location?.state?.taxYear,
              accept: "Y"
            },
          });
        } else {
          Modal.error({
            title: t("popup_error_title"),
            content: t("popup_error_content"),
            icon: '',
            onOk() {
              console.log('OnOKay');
            },
          });
        }

      }).catch((error) => {
        Modal.error({
          title: t("popup_error500_title"),
          content: t("popup_error500_content"),
          icon: '',
          onOk() {
            console.log('OnOKay');
          },
        });
        console.error('catch error', error);
      });

  }

  useEffect(() => {
  }, [location]);
  const currentDate = new Date();
  const tenYearsAgo = new Date(currentDate.getTime() - (3652 * 24 * 60 * 60 * 1000));
  const yearRange = Array.from({ length: (currentDate.getFullYear() + 1) - tenYearsAgo.getFullYear() }, (_, index) => currentDate.getFullYear() - index);
  const resultArray = yearRange.reverse();
  const options = resultArray.map(i => {
    return { value: i + 542 }
  }).filter((i:any) => i.value >= 2565);
  const handleChange = (value: string[]) => {
    setTaxYear(value);
    console.log(`selected ${value}`);
  };
  const tagRender = (props: CustomTagProps) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        color="default"
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    );
  };

  return (
    <>
      <div className="home-page">
        <div className="container">
          <Row className="container-main row">
            <div className="content-left col-sm-5">
              <a onClick={() => history.push("/contents/daolInv/consentRMF/otp")}>
                <Icon path={mdiArrowLeft} size="30" color="#FFFFFF" />
              </a>
              <div className="info-left">
                <p className="content-sub">
                  ข้าพเจ้ารับทราบว่า หลังจากที่ข้าพเจ้าแจ้งให้ บลจ. นำส่งข้อมูลย้อนหลังแก่กรมสรรพากรแล้ว ข้าพเจ้าไม่สามารถแก้ไข หรือเพิกถอนการส่งข้อมูลย้อนหลังได้
                </p>
              </div>
            </div>
            <div className="content-right col-sm-7">
              <p className=" text-header">
                แจ้งประสงค์ส่งข้อมูลการลงทุนย้อนหลัง
              </p>
              <div className="box-consent">
                <div>
                  {t("name")}<strong style={{ textDecoration: 'underline' }}>  {location?.state?.customerName}  </strong > {t("consent_descrip_p1")} <strong style={{ textDecoration: 'underline' }}>  {location?.state?.taxId}  </strong>
                  <Checkbox className="checkbox" onChange={(e: any) => setIsCheck(e.target.checked)}>
                    มีความประสงค์ให้ บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด นำส่งและเปิดเผยข้อมูลใดๆเกี่ยวกับการลงทุนในกองทุนรวมตลอดทั้งปีภาษีย้อนหลังของปี
                  </Checkbox>


                  <p className="consent-tax">
                    <Select
                      mode="multiple"
                      showArrow
                      placeholder="กรุณเลือกปีย้อนหลัง"
                      tagRender={tagRender}
                      defaultValue={[]}
                      style={{ width: '100%' }}
                      onChange={handleChange}
                      options={options}
                      disabled={!isCheck}
                    />
                    {/* <Row gutter={[16, 16]}>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2022
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2021
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2020
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2019
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2018
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2017
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2016
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2015
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2014
                        </Checkbox>
                      </Col>
                      <Col span={4}>
                        <Checkbox className="checkbox" onChange={checkAcceptance}>
                          2013
                        </Checkbox>
                      </Col>
                    </Row> */}
                  </p>
                </div>
                <div className="consent-tax">
                  ที่สามารถใช้สิทธิลดหย่อนภาษีได้ของข้าพเจ้าต่อกรมสรรพากร (สามารถย้อนหลังได้ไม่เกิน 10 ปีภาษี แต่ไม่เกินปี {dt.getFullYear() + 542}) เพื่อประโยชน์ในการใช้สิทธิยกเว้นภาษีเงินได้บุคคลธรรมดาของข้าพเจ้า ทั้งนี้ ตามหลักเกณฑ์ เงื่อนไขและวิธีการที่กรมสรรพกรกำหนด
                </div>
              </div>
              <Row className="container-button col-button">
                <Col span={12}>
                  <Button type="primary" onClick={onSubmit} disabled={(!isCheck || taxYear.length == 0)}>
                    {t("btn_confirm")}
                  </Button>
                </Col>
                <Col span={12}>
                  <Button className="back-page" href="https://www.daolinvestment.co.th/home">
                    {t("btn_backto_home")}
                  </Button>
                </Col>
              </Row>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};
export default ConsentBackInformationPage;
